// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skills-main-div {
  display: flex;
}

.skills-header {
  font-size: 60px;
  line-height: 1.1;
  font-family: "Google Sans Regular";
  text-align: center;
}

.skills-text {
  font-size: 20px;
}

.skills-text-div {
  margin-left: 50px;
  margin-top: 3%;
  padding-top: 80px;
  font-family: "Google Sans Regular";
}

.skills-main-div > * {
  flex: 1 1;
  margin-bottom: 30px;
}

.skills-image-div > * {
  max-width: 100%;
  height: auto;
  margin-top: 100px;
}

.skills-heading {
  font-size: 50px;
  font-weight: 400;
  text-align: center;
  padding-bottom: 10px;
  font-family: "Google Sans Regular";
}

/* Media Query */
@media (max-width: 1380px) {
  .skills-heading {
    font-size: 40px;
  }
  .skills-header {
    font-size: 50px;
  }
}
@media (max-width: 768px) {
  .skills-heading {
    font-size: 30px;
    text-align: center;
  }
  .skills-header {
    font-size: 30px;
  }
  .greeting-text-p {
    font-size: 16px;
    line-height: normal;
  }
  .skills-main-div {
    flex-direction: column;
  }
  .skills-text-div {
    margin-left: 0px;
    margin: 20px;
  }
  .skills-text {
    font-size: 16px;
  }
  .skills-text-subtitle {
    font-size: 16px;
    text-align: center;
  }
  .skills-image-div {
    order: 2;
  }
  .skills-image-div > * {
    margin-top: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/skills/Skills.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,gBAAgB;AAChB;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".skills-main-div {\n  display: flex;\n}\n\n.skills-header {\n  font-size: 60px;\n  line-height: 1.1;\n  font-family: \"Google Sans Regular\";\n  text-align: center;\n}\n\n.skills-text {\n  font-size: 20px;\n}\n\n.skills-text-div {\n  margin-left: 50px;\n  margin-top: 3%;\n  padding-top: 80px;\n  font-family: \"Google Sans Regular\";\n}\n\n.skills-main-div > * {\n  flex: 1;\n  margin-bottom: 30px;\n}\n\n.skills-image-div > * {\n  max-width: 100%;\n  height: auto;\n  margin-top: 100px;\n}\n\n.skills-heading {\n  font-size: 50px;\n  font-weight: 400;\n  text-align: center;\n  padding-bottom: 10px;\n  font-family: \"Google Sans Regular\";\n}\n\n/* Media Query */\n@media (max-width: 1380px) {\n  .skills-heading {\n    font-size: 40px;\n  }\n  .skills-header {\n    font-size: 50px;\n  }\n}\n@media (max-width: 768px) {\n  .skills-heading {\n    font-size: 30px;\n    text-align: center;\n  }\n  .skills-header {\n    font-size: 30px;\n  }\n  .greeting-text-p {\n    font-size: 16px;\n    line-height: normal;\n  }\n  .skills-main-div {\n    flex-direction: column;\n  }\n  .skills-text-div {\n    margin-left: 0px;\n    margin: 20px;\n  }\n  .skills-text {\n    font-size: 16px;\n  }\n  .skills-text-subtitle {\n    font-size: 16px;\n    text-align: center;\n  }\n  .skills-image-div {\n    order: 2;\n  }\n  .skills-image-div > * {\n    margin-top: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
